var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true}}),_c('main',[_c('RouterView')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }